export default "__VITE_ASSET__1ad3b168__"